import type { CanvasGroup } from '../types';

/**
 * Walk up the group hierarchy from `entityId`.
 * Collect consecutive invisible-mode parents.
 * Stop at: entered group, container-mode group, collapsed group, or no parent.
 * Return the outermost invisible ancestor, or null if none.
 */
export function resolveGroupRedirect(
  entityId: string,
  enteredGroupId: string | null,
  parentMap: Map<string, string>,
  groupMap: Map<string, CanvasGroup>,
): string | null {
  let outermostInvisible: string | null = null;
  let currentId = entityId;

  while (true) {
    const parentId = parentMap.get(currentId);
    if (!parentId) break;
    const parentGroup = groupMap.get(parentId);
    if (!parentGroup) break;
    if (parentId === enteredGroupId) break;
    if (parentGroup.collapsed) break;
    if (parentGroup.displayMode === 'container') break;
    outermostInvisible = parentId;
    currentId = parentId;
  }

  return outermostInvisible;
}
